export const getMapLink = (address: string): string => {
  const urlEncodedAdress = encodeURIComponent(address);

  // Detect iOS devices (iPad, iPhone, iPod)
  const isIOS = typeof navigator !== "undefined" && /iPad|iPhone|iPod/.test(navigator.userAgent);

  if (isIOS) {
    return `http://maps.apple.com/?daddr=${urlEncodedAdress}`;
  }

  // Default to Google Maps for all other devices
  return `https://www.google.com/maps/dir/?api=1&destination=${urlEncodedAdress}`;
};
